import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const CustomFormDialog = ({
  isOpen,
  onOpenChange,
  title,
  description,
  fields,
  formData,
  setFormData,
  formErrors,
  setFormErrors,
  onSubmit,
  cancelLabel = "İptal",
  submitLabel = "Ekle",
}) => {
  const handleChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
    setFormErrors({ ...formErrors, [fieldName]: "" });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-4 py-4">
          {fields.map(({ name, label, required, type, options }) => (
            <div key={name} className="grid gap-2">
              <Label htmlFor={name}>
                {label}
                {required && " *"}
              </Label>
              {type === "select" ? (
                <Select
                  value={formData[name] || ""}
                  onValueChange={(value) => handleChange(name, value)}
                >
                  <SelectTrigger className={formErrors[name] ? "border-red-500" : ""}>
                    <SelectValue placeholder="Seçiniz" />
                  </SelectTrigger>
                  <SelectContent>
                    {options.map((option) => (
                      <SelectItem key={option.value} value={option.value}>
                        {option.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              ) : (
                <Input
                  id={name}
                  value={formData[name] || ""}
                  onChange={(e) => handleChange(name, e.target.value)}
                  className={formErrors[name] ? "border-red-500" : ""}
                  required={required}
                />
              )}
              {formErrors[name] && (
                <p className="text-sm text-red-500">{formErrors[name]}</p>
              )}
            </div>
          ))}
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              onOpenChange(false);
              setFormErrors({});
            }}
          >
            {cancelLabel}
          </Button>
          <Button variant="default" onClick={onSubmit}>
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomFormDialog;
